import {
  USER_STATUS_INACTIVE,
  USER_STATUS_NOT_ACTIVATED,
  USER_STATUS_TYPE_INACTIVE,
  USER_STATUS_TYPE_NOT_ACTIVATED,
} from '../constants';

export const normalizeUserStatus = (statusType?: string): string => {
  if (statusType === USER_STATUS_TYPE_NOT_ACTIVATED) {
    return USER_STATUS_NOT_ACTIVATED;
  }

  if (statusType === USER_STATUS_TYPE_INACTIVE) {
    return USER_STATUS_INACTIVE;
  }

  return statusType ?? '';
};

export const toUserStatusType = (status: string): string => {
  if (status === USER_STATUS_NOT_ACTIVATED) {
    return USER_STATUS_TYPE_NOT_ACTIVATED;
  }

  if (status === USER_STATUS_INACTIVE) {
    return USER_STATUS_TYPE_INACTIVE;
  }

  return status;
};
